import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { fetchData, fetchPieChartData, fetchOrgChartData, fetchTableData } from '../reduxactions/organizationactions/OrgDashboardActions';
import { GFNButton } from '../ui/GFNButton';
import { useNavigate } from 'react-router-dom';

const OrganisationDashboard = () => {

    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchData(uid) as any);
                await dispatch(fetchPieChartData(uid) as any);
                await dispatch(fetchOrgChartData(uid) as any);
                await dispatch(fetchTableData(uid) as any);


            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);

    const data = useSelector((state: RootState) => state.orgdashboard.data);
    const piechartData = useSelector((state: RootState) => state.orgdashboard.pieChartData);
    console.log("piechartData", piechartData)

    const fundManagerchartData = useSelector((state: RootState) => state.orgdashboard.orgChartData);
    console.log("fundManagerchartData", fundManagerchartData)
    const piechartOptions = useSelector((state: RootState) => state.orgdashboard.piechartOptions);
    const fundManagerchartOptions = useSelector((state: RootState) => state.orgdashboard.orgChart);
    console.log("fundManagerchartOptions", fundManagerchartOptions)
    const orgTableData = useSelector((state: RootState) => state.orgdashboard.orgTableData);

    const navigate = useNavigate();

    const summary = data?.[0];
    const stats = useMemo(
        () => [
            {
                label: 'Applications',
                value: summary?.applications,
                icon: 'pi pi-file-text',
                className: 'app-stat-card--blue'
            },
            {
                label: 'Donations',
                value: summary?.donations,
                icon: 'pi pi-dollar',
                className: 'app-stat-card--green'
            },
            {
                label: 'Needs',
                value: summary?.needs,
                icon: 'pi pi-heart-fill',
                className: 'app-stat-card--rose'
            }
        ],
        [summary]
    );

    const Donates = () => {
        const url = `/receiveddonations`;
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/orgdashboard.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Dashboard</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <section className="content">
                            <div className="grid">
                                {stats.map((stat) => (
                                    <div className="col-12 md:col-4" key={stat.label}>
                                        <div className={`app-stat-card ${stat.className}`}>
                                            <div className="app-stat-card__content">
                                                <div>
                                                    <span className="app-stat-card__label">{stat.label}</span>
                                                    <div className="app-stat-card__value">{stat.value}</div>
                                                </div>
                                                <span className="app-stat-card__icon">
                                                    <i className={stat.icon}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="grid">

                                {/* Donations Chart */}
                                <section className="col-12 lg:col-6">

                                    <div className="surface-card shadow-3 border-round-2xl p-3 h-full">

                                        <Panel
                                            header="Donations Overview"
                                            toggleable
                                            className="app-panel border-none"
                                        >

                                            <div
                                                className="flex align-items-center justify-content-center"
                                                style={{
                                                    minHeight: '450px',
                                                    padding: '1rem'
                                                }}
                                            >

                                                <Chart
                                                    type="doughnut"
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '500px',
                                                        height: '420px'
                                                    }}
                                                    data={piechartData}
                                                    options={piechartOptions}
                                                />

                                            </div>

                                        </Panel>

                                    </div>

                                </section>

                                {/* Fund Manager Chart */}
                                <section className="col-12 lg:col-6">

                                    <div className="surface-card shadow-3 border-round-2xl p-3 h-full">

                                        <Panel
                                            header="Fund Manager Overview"
                                            toggleable
                                            className="app-panel border-none"
                                        >

                                            <div
                                                className="flex align-items-center justify-content-center"
                                                style={{
                                                    minHeight: '450px',
                                                    padding: '1rem'
                                                }}
                                            >

                                                <Chart
                                                    type="bar"
                                                    style={{
                                                        width: '100%',
                                                        height: '420px'
                                                    }}
                                                    data={fundManagerchartData}
                                                    options={fundManagerchartOptions}
                                                />

                                            </div>

                                        </Panel>

                                    </div>

                                </section>

                            </div>

                        </section>
                        <Panel header="Latest Donations" toggleable className="app-panel">
                            <section className="content">
                                <div className="app-table-toolbar">
                                    <h3 style={{ margin: 0 }}>Latest Donations</h3>
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                    </span>
                                </div>
                                <DataTable value={orgTableData} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                    <Column field="firstname" sortable header="Donor Name"></Column>
                                    <Column field="name" sortable header="Fundmanager Name"></Column>
                                    <Column field="Amount" sortable header="Amount"></Column>
                                    <Column field="CreateDate" sortable header="Date"></Column>
                                    <Column field="donationStatus" sortable header="Status" ></Column>
                                </DataTable>
                                <div className="flex justify-content-end mt-3">
                                    <GFNButton buttonType="primary" label="View All Donations" onClick={() => Donates()} />
                                </div>
                            </section>
                        </Panel>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default OrganisationDashboard
